module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "timelogger-basic"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "_label": "Timer",
      "suffix": "timer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.timelog.hours),
      expression: "timelog.hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "hoursinput",
    staticClass: "number-btns",
    attrs: {
      "type": "number",
      "min": "0.25",
      "max": "3",
      "step": "0.25",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.timelog.hours)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.timelog, "hours", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "_label": "Arbejdstype"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timelog.worktype),
      expression: "timelog.worktype"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.timelog, "worktype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Vælg arbejdstype...")]), _vm._v(" "), _vm._l((_vm.worktypes), function(option, i) {
    return _c('option', {
      key: 'fdsf' + i,
      domProps: {
        "value": option.key
      }
    }, [_vm._v(_vm._s(option.title))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "_label": "Note"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timelog.title),
      expression: "timelog.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Hvad har du lavet?"
    },
    domProps: {
      "value": (_vm.timelog.title)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.timelog, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary",
      "full": "",
      "disabled": !_vm.ready
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create()
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [_vm._v("Log " + _vm._s(_vm.timelog.hours || 0) + " time(r) på " + _vm._s(_vm.project.name))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f2077ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeloggerBasic.vue
// module id = 593
// module chunks = 1